module.exports = "/shifts/components/tips/availableShift-5e0bf1.html";